import * as wf from "client-api-workflow";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
const useDeleteWorkflowInstance = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  return useMutation(async (id: string) => {
    const list = await wf.deleteWorkflowInstance(id);
    console.log("deleteWorkflowInstance ", list);
  }, invalidateCache);
};

export default useDeleteWorkflowInstance;
